'use client';

import { useDecisions } from '../../hooks';
import { AdyenDataCollectionLegacy } from './AdyenDataCollection.legacy';

export const AdyenDataCollectionScript = () => {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <AdyenDataCollectionLegacy />;
};
